import { Component, OnInit, ViewChild } from '@angular/core';
import { dpAnimations } from '@dp/animations';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { AuthService } from '../auth.service';
import { UIService } from 'app/shared';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from 'app/settings/users/users.service';
import { CaptchaBase } from '../captcha.base';
import { MilestoneService } from '@dp/services/milestone.service';
import { ReCaptcha2Component } from 'ngx-captcha';

@Component({
  selector: 'dp-signup2',
  templateUrl: './signup2.component.html',
  styleUrls: ['./signup2.component.scss'],
  animations: dpAnimations,
})
export class Signup2Component extends CaptchaBase implements OnInit {
  //readonly siteKey = environment.recapchaKey;
  @ViewChild('captchaElem') captchaElem: ReCaptcha2Component;

  isFormBusy = false;
  showLogo = false;
  checkingEmail = false;
  waitingForVerify = false;
  resendUserBusy = false;
  resendUsed = false;
  f: UntypedFormGroup;
  email: string;
  orgDomain = '';
  recaptcha = null;

  // @ViewChild('emailInput', { static: true }) emailInput: NgModel;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService,
    private uiService: UIService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private milestoneService: MilestoneService
  ) {
    super();
  }

  ngOnInit(): void {
    //console.log("signup2");
    this.milestoneService.checkForEvent(environment.gaEvents.milestones.startRegisterAccount);

    this.f = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(environment.regex.emailValidation)])],
      recaptcha: ['', Validators.required],
    });
    // this.emailInput.control.valueChanges.pipe(debounceTime(environment.debounceTime), distinctUntilChanged()).subscribe((email) => {
    //   this.orgDomain = email.split('@').pop();
    //   this.reset();

    //   if (this.orgDomain && this.emailInput.control.status === 'VALID' && this.orgDomain.lastIndexOf('.') > this.orgDomain.indexOf('@')) {
    //     this.verifyImageURL('//logo.clearbit.com/' + this.orgDomain, (imageExist) => {
    //       if (imageExist) {
    //         this.showLogo = true;
    //       }
    //     });
    //     this.email = email;
    //   }
    // });
  }

  submit() {
    this.isFormBusy = true;
    this.authService
      .createEmail(this.f.value.email, this.f.value.recaptcha, this.getSourceParam(), this.authService.getGoogleAnalyticsInfo())
      .pipe(finalize(() => (this.isFormBusy = false)))
      .subscribe(
        (result) => {
          this.resetRecaptcha();
          this.email = this.f.value.email;
          if (result.status === 'EXISTING') {
            this.router.navigate(['/login'], { queryParams: { email: this.f.value.email, previousUrl: '/signup' } });
          } else if (result.status === 'NEW') {
            this.waitingForVerify = true;
            this.milestoneService.checkForEvent(environment.gaEvents.milestones.endRegisterAccount);
          }
        },
        (error) => {
          this.resetRecaptcha();
          this.uiService.showSnackbar(error.message, null, { duration: environment.snackBarDuration.warning, panelClass: 'warn' });
        }
      );
  }

  resetRecaptcha() {
    this.captchaElem.reloadCaptcha();
    this.recaptcha = null;
  }

  getSourceParam(): string {
    return this.activatedRoute.snapshot.queryParamMap.get('source');
  }

  resend() {
    this.resendUserBusy = true;

    this.authService
      .createEmail(this.f.value.email, this.recaptcha, this.getSourceParam(), this.authService.getGoogleAnalyticsInfo())
      .pipe(
        finalize(() => {
          this.resendUserBusy = false;
          this.resendUsed = true;
        })
      )
      .subscribe(
        () => {
          this.resetRecaptcha();
          this.uiService.showSnackbar('The email was just sent!', null, { duration: 3000, panelClass: 'accent' });
        },
        () => {
          this.resetRecaptcha();
          this.uiService.showSnackbar('We can not send email right now. Please try again later.', null, {
            duration: 6000,
            panelClass: 'warn',
          });
        }
      );
  }

  getErrorMessage(control: UntypedFormControl) {
    let msg = '';
    if (control.hasError('required')) {
      msg = 'Email is required';
    } else if (control.hasError('email') || control.hasError('pattern')) {
      msg = 'This is not a valid email address.';
    }
    return msg;
  }
}
